import '../assets/styles/Expertise.scss';

import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAndroid, faCodiepie, faGithub } from '@fortawesome/free-brands-svg-icons';
import Chip from '@mui/material/Chip';

const labelsFirst = [
    "C++",
    "Vulkan",
    "CMake",
    "SFML",
    "Arduino",
    "Unreal Engine 5",
    "Unity",
];

const labelsSecond = [
    "Git",
    "Linux",
    "GitHub Actions",
];

const labelsThird = [
    "Android Studio",
    "Kotlin",
    "Jetpack Compose",
    "Room",
];

function Expertise() {
    return (
    <div className="container" id="expertise">
        <div className="skills-container">
            <h1>Expertise</h1>
            <div className="skills-grid">
                <div className="skill">
                    <FontAwesomeIcon icon={faCodiepie} size="3x"/>
                    <h3>C++ Development & Frameworks</h3>
                    <p>I have developed multiple game engines and video games using C++ with various frameworks.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsFirst.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faGithub} size="3x"/>
                    <h3>DevOps & Automation</h3>
                    <p>After building the application, I set up CI/CD pipelines and deployment automation to ensure a smooth production release.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsSecond.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faAndroid} size="3x"/>
                    <h3>Android App Development</h3>
                    <p>I have hands-on experience in building Android applications with modern technologies.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsThird.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}

export default Expertise;